import { twMerge } from "tailwind-merge";
import { Type } from "../Type";

export type Props = {
  /** Current step number (1-indexed) */
  currentStep: number;
  /** Total number of steps */
  totalSteps: number;
  /** Optional prefix like "Step" - if omitted, renders "X of Y" */
  prefix?: string;
  /** Additional CSS classes */
  className?: string;
};

/**
 * Step progress indicator.
 * Displays current step out of total steps in a consistent format.
 *
 * @example
 * // Renders "1 of 5"
 * <StepProgress currentStep={1} totalSteps={5} />
 *
 * @example
 * // Renders "Step 1 of 5"
 * <StepProgress currentStep={1} totalSteps={5} prefix="Step" />
 */
export function StepProgress({
  currentStep,
  totalSteps,
  prefix,
  className,
}: Props) {
  return (
    <Type
      variant="h6" as="span"
      className={twMerge("text-brand-700", className)}
      data-testid="step-progress"
    >
      {prefix ? `${prefix} ${currentStep}` : currentStep} of {totalSteps}
    </Type>
  );
}

export default StepProgress;
